import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { useForm } from "react-hook-form";
import { Modal } from "../../components/Modal";
import InputField from "../../components/InputField";
import { OptionRoom } from "../../types/optionRoom";

interface AddRoomModalProps {
  onSave: (roomName: string) => void;
  onCancel: () => void;
  isOpen: boolean;
  existingRooms: OptionRoom[];
}

type FormData = {
  roomName: string;
};

const getDefaultValues = (): FormData => {
  return {
    roomName: "",
  };
};

export const AddRoomModal: React.FC<AddRoomModalProps> = ({
  onSave,
  onCancel,
  isOpen,
  existingRooms,
}) => {

  const { watch, register } = useForm<FormData>({
    defaultValues: getDefaultValues(),
  });

  const roomName: string = watch("roomName");
  const [roomNameError, setRoomNameError] = useState<string | null>(null);

  const onSaveClick = () => {
    if (existingRooms.filter((opt) => opt === roomName).length > 0) {
      setRoomNameError("Room already exists");
      return;
    }
    setRoomNameError(null);
    onSave(roomName);
  };

  return (
    <Modal heading={"Add Room"} isOpen={isOpen}>
      <Box
        component="form"
        sx={{ width: { xs: "100%", sm: "552px" } }}
        onSubmit={(e) => {
          e.preventDefault();
          onSaveClick();
        }}
      >
        <InputField
          {...register("roomName")}
          label="Room Name"
          placeholder="Enter Room Name"
          required
          fullWidth
          error={!!roomNameError}
          helperText={roomNameError ?? ""}
        />
        <Box
          sx={{ mt: 2, display: "flex", justifyContent: "end" }}
        >
          <Button variant="outlined" onClick={onCancel} sx={{ marginRight: 2 }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            type="button"
            color="primary"
            disabled={roomName === ""}
            onClick={onSaveClick}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
